import { render, staticRenderFns } from "./geo-selector.vue?vue&type=template&id=59822a3b"
import script from "./geo-selector.vue?vue&type=script&lang=js"
export * from "./geo-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports